import React, { useContext, useEffect, useState } from 'react';
import SurveyQuestion from '../SurveyQuestion';
import Toast from '../../../components/toast/Toast';
import '../createSurvey.css';
import Navbar from '../../../components/navbar/Navbar';
import Steps from '../../../components/steps';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../../components/navbar/Footer';
import { StepsContext } from '../../../context/stepsContext';
import parse from 'html-react-parser';
import Pickles from '../../../components/particles/Pickles';
import { REACT_APP_SURVEY_ID, REACT_APP_SURVEY_ID_ER } from '../../../config';

export default function StepTwo({ minutesDisplay, secondsDisplay }) {
  const [pickle, setPickle] = useState(false);
  const [stepTwo, setStepTwo] = useState(0);

  const { state: stepOneDatas } = useLocation();
  const { state } = stepOneDatas;
  const { stepone } = stepOneDatas;
  const { survey_id } = stepOneDatas;
  const { personType } = stepOneDatas;
  const { dispatch, start } = useContext(StepsContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (!start) navigate('/pageNotfound');
  }, [start, navigate]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let selected = state && parseInt(state?.score) > 40 ? 'top' : 'bottom';
  const message =
    state?.score > 60 && stepTwo !== 1
      ? `You have reported a <b>high</b> ${
          REACT_APP_SURVEY_ID_ER === survey_id ? 'workplace' : 'wellbeing'
        } experience.  Please tell us why you scored these statements <b>highest</b> and what feelings these generate about your ${
          REACT_APP_SURVEY_ID_ER === survey_id
            ? 'experience at work'
            : 'wellbeing'
        }.`
      : state?.score > 60 && stepTwo === 1
      ? `Whilst you have reported a <b>high</b> ${
          REACT_APP_SURVEY_ID_ER === survey_id ? 'workplace' : 'wellbeing'
        } experience, to help further improve your overall ${
          REACT_APP_SURVEY_ID_ER === survey_id
            ? 'experience at work'
            : 'wellbeing'
        } please explain why you scored these three statement the lowest.`
      : state?.score > 40 && state?.score <= 60 && stepTwo !== 1
      ? `You have reported a <b>moderate</b> ${
          REACT_APP_SURVEY_ID_ER === survey_id ? 'workplace' : 'wellbeing'
        } experience with some <b>high</b> and <b>low</b> scores.  Please tell us why you scored these statements <b>highest</b> and what feelings these generate about your ${
          REACT_APP_SURVEY_ID_ER === survey_id
            ? 'experience at work'
            : 'wellbeing'
        }.`
      : state?.score > 40 && state?.score <= 60 && stepTwo === 1
      ? `You have reported a <b>moderate</b> ${
          REACT_APP_SURVEY_ID_ER === survey_id ? 'workplace' : 'wellbeing'
        } experience with some <b>high</b> and <b>low</b> scores. To help improve your overall ${
          REACT_APP_SURVEY_ID_ER === survey_id ? 'experience' : 'wellbeing'
        } please explain why you scored these three statement the lowest.`
      : state?.score <= 40 && stepTwo === 1
      ? `Whilst you have reported a <b>high</b> ${
          REACT_APP_SURVEY_ID_ER === survey_id ? 'workplace' : 'wellbeing'
        } experience, to help further improve your overall ${
          REACT_APP_SURVEY_ID_ER === survey_id ? 'experience' : 'wellbeing'
        } please explain why you scored these three statement the lowest.`
      : `You have reported here a <b>low</b> ${
          REACT_APP_SURVEY_ID_ER === survey_id ? 'workplace' : 'wellbeing'
        } experience. To help improve your overall ${
          REACT_APP_SURVEY_ID_ER === survey_id ? 'experience' : 'wellbeing'
        } please explain why you scored these three statement the lowest.`;

  console.log(state.score);

  const servicesTop = state?.topConstructs?.map((construct, index) => ({
    id: index + 1,
    name: construct,
  }));
  const servicesBottom = state?.bottomConstructs?.map((construct, index) => ({
    id: index + 1,
    name: construct,
  }));

  let questions = [
    {
      id: 1,
      question:
        state && selected === 'top' && !(stepTwo === 1)
          ? state?.topscoresquestions[0]?.question
          : Object?.values(state?.bottomscoresquestions[0])[0]?.question,
      options: [
        { input: true },
        {
          option:
            state &&
            Object?.values(state?.bottomscoresquestions[0])[0]?.splits[0],
          value: 'a',
        },
        {
          option:
            state &&
            Object?.values(state?.bottomscoresquestions[0])[0]?.splits[1],
          value: 'b',
        },
        {
          value: 'c',
          option:
            state &&
            Object?.values(state?.bottomscoresquestions[0])[0]?.splits[2],
        },
      ],
      input: '',
    },
    {
      id: 2,
      question:
        state && selected === 'top' && !(stepTwo === 1)
          ? state?.topscoresquestions[1]?.question
          : Object?.values(state?.bottomscoresquestions[1])[0]?.question,
      options: [
        { input: true },
        {
          value: 'a',
          option:
            state &&
            Object?.values(state?.bottomscoresquestions[1])[0]?.splits[0],
        },
        {
          value: 'b',
          option:
            state &&
            Object?.values(state?.bottomscoresquestions[1])[0]?.splits[1],
        },
        {
          value: 'c',
          option:
            state &&
            Object?.values(state?.bottomscoresquestions[1])[0]?.splits[2],
        },
      ],
      input: '',
    },
    {
      id: 3,
      question:
        state && selected === 'top' && !(stepTwo === 1)
          ? state?.topscoresquestions[2]?.question
          : Object?.values(state?.bottomscoresquestions[2])[0]?.question,
      options: [
        { input: true },
        {
          value: 'a',
          option:
            state &&
            Object?.values(state?.bottomscoresquestions[2])[0]?.splits[0],
        },
        {
          value: 'b',
          option:
            state &&
            Object?.values(state?.bottomscoresquestions[2])[0]?.splits[1],
        },
        {
          value: 'c',
          option:
            state &&
            Object?.values(state?.bottomscoresquestions[2])[0]?.splits[2],
        },
      ],
      input: '',
    },
  ];
  const [toastState, setToastState] = React.useState({
    open: false,
  });
  const handleCloseToast = () => {
    setToastState({
      open: !toastState.open,
    });
  };

  const [chosen, setChosen] = useState([]);
  const handleClick = (services) => {
    ((state.score > 65 && chosen.length === 3) ||
      (state.score < 65 && chosen.length === 3)) &&
    !chosen.includes(services)
      ? handleCloseToast()
      : setChosen(
          chosen.includes(services)
            ? chosen?.filter((n) => n !== services)
            : () => [...chosen, services]
        );
  };
  const [chosenTop, setChosenTop] = useState([]);
  const handleClickTop = (services) => {
    ((state.score > 65 && chosenTop.length === 3) ||
      (state.score < 65 && chosenTop.length === 3)) &&
    !chosenTop.includes(services)
      ? handleCloseToast()
      : setChosenTop(
          chosenTop.includes(services)
            ? chosenTop?.filter((n) => n !== services)
            : () => [...chosenTop, services]
        );
  };
  const handleClickNav = () => {
    setStepTwo(() => stepTwo + 1);
    stepTwo !== 1 && selected === 'top' && window.scrollTo(0, 0);
    (stepTwo === 1 || selected === 'bottom') && setPickle(true);
    (stepTwo === 1 || selected === 'bottom') &&
      setTimeout(() => {
        setPickle(false);
        dispatch({ type: 'STEP' });
        navigate('/steptwo-2', {
          state: {
            state: state,
            keyAreaTopTexts: keyAreaTopTexts,
            selectedConstructsTop: selectedConstructsTop,
            selectedConstructsBottom: selectedConstructsBottom,
            stepone: stepone,
            selected: selected,
            survey_id: survey_id,
            personType: personType,
          },
        });
      }, 1000);
  };

  const [firstInput, setFirstinput] = useState('');
  const [secondInput, setSecondinput] = useState('');
  const [thirdInput, setThirdinput] = useState('');
  const [firstInputTop, setFirstinputTop] = useState('');
  const [secondInputTop, setSecondinputTop] = useState('');
  const [thirdInputTop, setThirdinputTop] = useState('');
  const [firstOption, setFirstOption] = useState('');
  const [secondOption, setSecondOption] = useState('');
  const [thirdOption, setThirdOption] = useState('');

  let selectedConstructsTop = chosenTop;
  let selectedConstructsBottom = chosen;
  let keyAreaTopTexts = {
    keyAreaTopTexts: {
      1: firstInputTop,
      2: secondInputTop,
      3: thirdInputTop,
    },
    keyAreaBottomTexts: {
      1: firstInput || firstOption,
      2: secondInput || secondOption,
      3: thirdInput || thirdOption,
    },
  };

  const Altered =
    (firstInput?.length > 0 ||
      (firstOption?.length > 0 && firstOption !== 'Other')) &&
    (secondInput?.length > 0 ||
      (secondOption?.length > 0 && secondOption !== 'Other')) &&
    (thirdInput?.length > 0 ||
      (thirdOption?.length > 0 && thirdOption !== 'Other'));

  console.log(
    (stepTwo === 1 && !Altered) ||
      (stepTwo === 1
        ? chosenTop?.length < 1 || chosen?.length < 1
        : (firstInput?.length < 1 &&
            secondInput?.length < 1 &&
            thirdInput?.length < 1) ||
          chosen?.length < 1)
  );
  console.log(stepTwo);
  console.log('state', state);
  console.log('state', survey_id);
  console.log(stepTwo === 1);
  console.log(Altered);
  console.log(state?.score <= 65 && chosenTop?.length);
  console.log(state?.score <= 65 && chosen?.length);
  console.log(chosenTop?.length);
  console.log(chosen?.length);

  return (
    <div className="mainContainer">
      <Navbar
        special={
          REACT_APP_SURVEY_ID === survey_id ||
          REACT_APP_SURVEY_ID_ER === survey_id
        }
        minutesDisplay={minutesDisplay}
        secondsDisplay={secondsDisplay}
      />

      {pickle && <Pickles />}
      <div className="surveys-sub-container">
        <Steps er={REACT_APP_SURVEY_ID_ER === survey_id} step={2} active />
        <div className="inst-c">
          <div className="surveys-question-title">{parse(message)}</div>
        </div>
        <div className="surveys-question-container survey-slider-container">
          <div className="allQuestionContainer">
            <div className="allQuestionTitle">
              Your three{' '}
              {state?.score > 40 && stepTwo !== 1 ? 'highest' : 'lowest'}{' '}
              scoring questions were
            </div>
            {questions?.map((question) => (
              <SurveyQuestion
                stepTwo={stepTwo}
                setFirstinput={setFirstinput}
                setSecondinput={setSecondinput}
                setThirdinput={setThirdinput}
                setFirstinputTop={setFirstinputTop}
                setSecondinputTop={setSecondinputTop}
                setThirdinputTop={setThirdinputTop}
                setFirstOption={setFirstOption}
                setSecondOption={setSecondOption}
                setThirdOption={setThirdOption}
                firstInput={firstInput}
                secondInput={secondInput}
                thirdInput={thirdInput}
                firstOption={firstOption}
                secondOption={secondOption}
                thirdOption={thirdOption}
                key={question?.id}
                question={question}
                selected={selected}
              />
            ))}
          </div>
          <div className="surveyServices">
            <div className="ssTitle">
              {(stepTwo === 0 || state.score < 65) && (
                <p style={{ fontSize: '18px', fontWeight: 600 }}>
                  {REACT_APP_SURVEY_ID_ER === survey_id
                    ? 'Choose up to 3 feelings to describe how these aspects of your experience at work make you feel.'
                    : 'Choose up to 3 feelings to describe how these aspects of your wellbeing experience make you feel.'}
                </p>
              )}
              {/* <p style={{ fontSize: '15px', fontWeight: 400 }}>
                * Choose up to 3 feelings
              </p> */}
            </div>
            {stepTwo === 0 && state.score > 65 && (
              <div
                style={{
                  border: '3px solid #2497A6',
                  color: chosenTop.includes('I feel great')
                    ? '#fff'
                    : '#2497A6',
                  backgroundColor: chosenTop.includes('I feel great')
                    ? '#2497A6'
                    : '#fff',
                }}
                className="sslistitem"
                onClick={() => handleClickTop('I feel great')}
              >
                I feel great
              </div>
            )}
            {(stepTwo === 0 || state.score < 65) && (
              <div className="ssItem">
                {stepTwo !== 1 &&
                  selected === 'top' &&
                  servicesTop?.map((service) => (
                    <div
                      style={{
                        border: '3px solid #2497A6',
                        color: chosenTop.includes(service?.name)
                          ? '#fff'
                          : '#2497A6',
                        backgroundColor: chosenTop.includes(service?.name)
                          ? '#2497A6'
                          : '#fff',
                      }}
                      key={service?.id}
                      onClick={() => handleClickTop(service?.name)}
                      className="sslistitem"
                    >
                      {service?.name}
                    </div>
                  ))}
                {(stepTwo === 1 || selected === 'bottom') &&
                  servicesBottom?.map((service) => (
                    <div
                      style={{
                        border: '3px solid #2497A6',
                        color: chosen.includes(service?.name)
                          ? '#fff'
                          : '#2497A6',
                        backgroundColor: chosen.includes(service?.name)
                          ? '#2497A6'
                          : '#fff',
                      }}
                      key={service?.id}
                      onClick={() => handleClick(service?.name)}
                      className="sslistitem"
                    >
                      {service?.name}
                    </div>
                  ))}
              </div>
            )}
          </div>
          <Toast
            handleClose={handleCloseToast}
            state={toastState}
            error="Sorry, You cannot choose more than 3."
          />
        </div>
        <div className="btn-container">
          {/* <Link to={'/steptwo-2'}> */}
          <Button
            disabled={
              (stepTwo === 1 && !Altered) ||
              (stepTwo === 1
                ? (state?.score < 65 && chosenTop?.length < 1) ||
                  (state?.score < 65 && chosen?.length < 1)
                : state?.score <= 40
                ? !Altered || chosen?.length < 1
                : firstInputTop?.length < 1 &&
                  secondInputTop?.length < 1 &&
                  thirdInputTop?.length < 1)
            }
            onClick={handleClickNav}
            className="signupCVbtnSign"
            type="submit"
            variant="contained"
            style={{
              backgroundColor:
                (stepTwo === 1 && !Altered) ||
                (stepTwo === 1
                  ? (state?.score < 65 && chosenTop?.length < 1) ||
                    (state?.score < 65 && chosen?.length < 1)
                  : state?.score <= 40
                  ? !Altered || chosen?.length < 1
                  : firstInputTop?.length < 1 &&
                    secondInputTop?.length < 1 &&
                    thirdInputTop?.length < 1)
                  ? ''
                  : '#2691a3',
            }}
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              padding: '8px 30px',
              textTransform: 'capitalize',
              backgroundColor: '#2691a3',
              '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                backgroundColor: '#2691a3',
              },
            }}
          >
            Next
          </Button>
          {/* </Link> */}
        </div>

        <Footer />
      </div>
    </div>
  );
}
